var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defer = require('p-defer');

var Headers = require('./extract-headers');

var LteReader = require('./lte-reader');

function getPadding(size) {
  size &= 511;
  return size && 512 - size;
}

function discardPadding(_x, _x2) {
  return _discardPadding.apply(this, arguments);
}

function _discardPadding() {
  _discardPadding = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(reader, size) {
    var overflow;
    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            overflow = getPadding(size);

            if (!overflow) {
              _context5.next = 4;
              break;
            }

            _context5.next = 4;
            return reader.next(overflow);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));
  return _discardPadding.apply(this, arguments);
}

module.exports = function (options) {
  options = options || {};
  options.highWaterMark = options.highWaterMark || 1024 * 16;
  return function (source) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var reader, gnuLongPath, gnuLongLinkPath, paxGlobal, pax, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _ret;

      return _regeneratorRuntime.wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              reader = LteReader(source);
              _context4.prev = 1;
              _loop =
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _loop() {
                var headerBytes, _ref4, done, value, header, _ref5, _done, gnuLongPathBytes, _ref6, _done2, gnuLongLinkPathBytes, _ref7, _done3, paxGlobalBytes, _ref8, _done4, paxBytes, bytesRemaining, bodyConsumed, firstChunk, body, _;

                return _regeneratorRuntime.wrap(function _loop$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        headerBytes = void 0;
                        _context3.prev = 1;
                        _context3.next = 4;
                        return _awaitAsyncGenerator(reader.next(512));

                      case 4:
                        _ref4 = _context3.sent;
                        done = _ref4.done;
                        value = _ref4.value;

                        if (!done) {
                          _context3.next = 9;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 9:
                        headerBytes = value;
                        _context3.next = 17;
                        break;

                      case 12:
                        _context3.prev = 12;
                        _context3.t0 = _context3["catch"](1);

                        if (!(_context3.t0.code === 'ERR_UNDER_READ')) {
                          _context3.next = 16;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 16:
                        throw _context3.t0;

                      case 17:
                        header = Headers.decode(headerBytes, options.filenameEncoding);

                        if (header) {
                          _context3.next = 20;
                          break;
                        }

                        return _context3.abrupt("return", "continue");

                      case 20:
                        if (!(header.type === 'gnu-long-path')) {
                          _context3.next = 32;
                          break;
                        }

                        _context3.next = 23;
                        return _awaitAsyncGenerator(reader.next(header.size));

                      case 23:
                        _ref5 = _context3.sent;
                        _done = _ref5.done;
                        gnuLongPathBytes = _ref5.value;

                        if (!_done) {
                          _context3.next = 28;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 28:
                        gnuLongPath = Headers.decodeLongPath(gnuLongPathBytes, options.filenameEncoding);
                        _context3.next = 31;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 31:
                        return _context3.abrupt("return", "continue");

                      case 32:
                        if (!(header.type === 'gnu-long-link-path')) {
                          _context3.next = 44;
                          break;
                        }

                        _context3.next = 35;
                        return _awaitAsyncGenerator(reader.next(header.size));

                      case 35:
                        _ref6 = _context3.sent;
                        _done2 = _ref6.done;
                        gnuLongLinkPathBytes = _ref6.value;

                        if (!_done2) {
                          _context3.next = 40;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 40:
                        gnuLongLinkPath = Headers.decodeLongPath(gnuLongLinkPathBytes, options.filenameEncoding);
                        _context3.next = 43;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 43:
                        return _context3.abrupt("return", "continue");

                      case 44:
                        if (!(header.type === 'pax-global-header')) {
                          _context3.next = 56;
                          break;
                        }

                        _context3.next = 47;
                        return _awaitAsyncGenerator(reader.next(header.size));

                      case 47:
                        _ref7 = _context3.sent;
                        _done3 = _ref7.done;
                        paxGlobalBytes = _ref7.value;

                        if (!_done3) {
                          _context3.next = 52;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 52:
                        paxGlobal = Headers.decodePax(paxGlobalBytes, options.filenameEncoding);
                        _context3.next = 55;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 55:
                        return _context3.abrupt("return", "continue");

                      case 56:
                        if (!(header.type === 'pax-header')) {
                          _context3.next = 69;
                          break;
                        }

                        _context3.next = 59;
                        return _awaitAsyncGenerator(reader.next(header.size));

                      case 59:
                        _ref8 = _context3.sent;
                        _done4 = _ref8.done;
                        paxBytes = _ref8.value;

                        if (!_done4) {
                          _context3.next = 64;
                          break;
                        }

                        return _context3.abrupt("return", {
                          v: void 0
                        });

                      case 64:
                        pax = Headers.decodePax(paxBytes, options.filenameEncoding);
                        if (paxGlobal) pax = _objectSpread({}, paxGlobal, {}, pax);
                        _context3.next = 68;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 68:
                        return _context3.abrupt("return", "continue");

                      case 69:
                        if (gnuLongPath) {
                          header.name = gnuLongPath;
                          gnuLongPath = null;
                        }

                        if (gnuLongLinkPath) {
                          header.linkname = gnuLongLinkPath;
                          gnuLongLinkPath = null;
                        }

                        if (pax) {
                          if (pax.path) header.name = pax.path;
                          if (pax.linkpath) header.linkname = pax.linkpath;
                          if (pax.size) header.size = parseInt(pax.size, 10);
                          header.pax = pax;
                          pax = null;
                        }

                        if (!(!header.size || header.type === 'directory')) {
                          _context3.next = 76;
                          break;
                        }

                        _context3.next = 75;
                        return {
                          header: header,
                          body: _wrapAsyncGenerator(
                          /*#__PURE__*/
                          _regeneratorRuntime.mark(function _callee() {
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }))()
                        };

                      case 75:
                        return _context3.abrupt("return", "continue");

                      case 76:
                        bytesRemaining = header.size;
                        bodyConsumed = defer(); // Prefetch the first chunk.
                        // This allows us to stream entries for small files from the tar without
                        // explicitly streaming the body of each.

                        _context3.next = 80;
                        return _awaitAsyncGenerator(reader.nextLte(Math.min(bytesRemaining, options.highWaterMark)));

                      case 80:
                        firstChunk = _context3.sent;
                        bytesRemaining -= firstChunk.value.length;
                        if (!bytesRemaining) bodyConsumed.resolve();
                        body = _wrapAsyncGenerator(
                        /*#__PURE__*/
                        _regeneratorRuntime.mark(function _callee2() {
                          var _ref9, _done5, _value2;

                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.prev = 0;
                                  _context2.next = 3;
                                  return firstChunk.value;

                                case 3:
                                  if (!bytesRemaining) {
                                    _context2.next = 17;
                                    break;
                                  }

                                  _context2.next = 6;
                                  return _awaitAsyncGenerator(reader.nextLte(bytesRemaining));

                                case 6:
                                  _ref9 = _context2.sent;
                                  _done5 = _ref9.done;
                                  _value2 = _ref9.value;

                                  if (!_done5) {
                                    _context2.next = 12;
                                    break;
                                  }

                                  bytesRemaining = 0;
                                  return _context2.abrupt("return");

                                case 12:
                                  bytesRemaining -= _value2.length;
                                  _context2.next = 15;
                                  return _value2;

                                case 15:
                                  _context2.next = 3;
                                  break;

                                case 17:
                                  _context2.prev = 17;
                                  bodyConsumed.resolve();
                                  return _context2.finish(17);

                                case 20:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2, null, [[0,, 17, 20]]);
                        }))();
                        _context3.next = 86;
                        return {
                          header: header,
                          body: body
                        };

                      case 86:
                        _context3.next = 88;
                        return _awaitAsyncGenerator(bodyConsumed.promise);

                      case 88:
                        if (!bytesRemaining) {
                          _context3.next = 121;
                          break;
                        }

                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _context3.prev = 91;
                        _iterator = _asyncIterator(body);

                      case 93:
                        _context3.next = 95;
                        return _awaitAsyncGenerator(_iterator.next());

                      case 95:
                        _step = _context3.sent;
                        _iteratorNormalCompletion = _step.done;
                        _context3.next = 99;
                        return _awaitAsyncGenerator(_step.value);

                      case 99:
                        _value = _context3.sent;

                        if (_iteratorNormalCompletion) {
                          _context3.next = 105;
                          break;
                        }

                        _ = _value;

                      case 102:
                        _iteratorNormalCompletion = true;
                        _context3.next = 93;
                        break;

                      case 105:
                        _context3.next = 111;
                        break;

                      case 107:
                        _context3.prev = 107;
                        _context3.t1 = _context3["catch"](91);
                        _didIteratorError = true;
                        _iteratorError = _context3.t1;

                      case 111:
                        _context3.prev = 111;
                        _context3.prev = 112;

                        if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                          _context3.next = 116;
                          break;
                        }

                        _context3.next = 116;
                        return _awaitAsyncGenerator(_iterator.return());

                      case 116:
                        _context3.prev = 116;

                        if (!_didIteratorError) {
                          _context3.next = 119;
                          break;
                        }

                        throw _iteratorError;

                      case 119:
                        return _context3.finish(116);

                      case 120:
                        return _context3.finish(111);

                      case 121:
                        _context3.next = 123;
                        return _awaitAsyncGenerator(discardPadding(reader, header.size));

                      case 123:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _loop, null, [[1, 12], [91, 107, 111, 121], [112,, 116, 120]]);
              });

            case 3:
              if (!true) {
                _context4.next = 14;
                break;
              }

              return _context4.delegateYield(_loop(), "t0", 5);

            case 5:
              _ret = _context4.t0;
              _context4.t1 = _ret;
              _context4.next = _context4.t1 === "continue" ? 9 : 10;
              break;

            case 9:
              return _context4.abrupt("continue", 3);

            case 10:
              if (!(typeof _ret === "object")) {
                _context4.next = 12;
                break;
              }

              return _context4.abrupt("return", _ret.v);

            case 12:
              _context4.next = 3;
              break;

            case 14:
              _context4.prev = 14;
              _context4.next = 17;
              return _awaitAsyncGenerator(reader.return());

            case 17:
              return _context4.finish(14);

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee3, null, [[1,, 14, 18]]);
    }))();
  };
};